module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __donate __limited-edu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-2 col-md-10 col-lg-push-2 col-md-8"
  }, [_c('div', {
    staticClass: "product product--inline"
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "radius block shadow"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": true,
      "product": _vm.product,
      "classes": "col-1-5"
    },
    model: {
      value: (_vm.product.price),
      callback: function($$v) {
        _vm.$set(_vm.product, "price", $$v)
      },
      expression: "product.price"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__wrapper mt-15 mb-15"
  }, [_c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg"
  }, [_vm._v("\n                  ไม่ต้องการรับของ\n                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "value": ""
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardProduct, "")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", "")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg",
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_vm._v("\n                  รับเสื้อยืดรุ่นพิเศษ สกรีนชื่อของคุณแบบ Personalised ได้ "), _c('small', [_vm._v("พร้อมจัดส่งให้ถึงบ้านหลังจากจบโครงการ (บริจาค 500 บาทขึ้นไป)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "value": "Customized T-Shirt",
      "disabled": _vm.isRewardDisabled
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardProduct, "Customized T-Shirt")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", "Customized T-Shirt")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attributes.info.rewardProduct === 'Customized T-Shirt'),
      expression: "attributes.info.rewardProduct === 'Customized T-Shirt'"
    }],
    staticClass: "slide-down-wrapper",
    class: {
      disable: _vm.product.price < 500
    }
  }, [_c('div', {
    staticClass: "form__section block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--lmt-deu"
  }, [_c('div', {}, [_c('div', {}, [_c('img', {
    staticClass: "ma-auto d-block pd-15",
    attrs: {
      "src": "/static/img/limited-edu/lmt-edu-shirt-01.png",
      "alt": "Limited Education",
      "width": "90%"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.attributes.info.rewardProduct === 'Customized T-Shirt') ? _c('div', [_c('div', {
    staticClass: "form__item--block"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "lmt-name"
    }
  }, [_c('strong', [_vm._v("คำที่ต้องการสกรีน")]), _vm._v(" "), _c('span', {
    staticClass: "fs-xs text-remark"
  }, [_vm._v("(ภาษาไทยเท่านั้น - ไม่เกิน 11 ตัวอักษร)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.attributes.info.rewardConfigText),
      expression: "attributes.info.rewardConfigText",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form__text",
    attrs: {
      "type": "text",
      "disabled": _vm.isRewardDisabled,
      "name": "lmt-name",
      "id": "lmt-name",
      "placeholder": "กรุณาพิมพ์คำที่ต้องการให้สกรีนบนเสื้อ"
    },
    domProps: {
      "value": (_vm.attributes.info.rewardConfigText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attributes.info, "rewardConfigText", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.error.rewardConfigText) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("ภาษาไทยเท่านั้น ไม่เกิน 11 ตัวอักษร")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form__item--block"
  }, [_c('div', {
    staticClass: "form__label"
  }, [_c('strong', [_vm._v("ขนาดเสื้อ")])]), _vm._v(" "), _c('div', {
    staticClass: "form__btn-group form__btn-group--inline",
    class: {
      disable: _vm.product.price < 500
    }
  }, [_c('div', {
    staticClass: "form__btn-group-item",
    class: {
      active: _vm.attributes.info.rewardConfigSize === 's'
    }
  }, [_c('label', {
    staticClass: "btn btn-size"
  }, [_vm._v("\n                                    S\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    attrs: {
      "type": "radio",
      "name": "size",
      "value": "s",
      "disabled": _vm.isRewardDisabled
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigSize, "s")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigSize", "s")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-remark"
  }, [_vm._v("รอบอก 36 นิ้ว")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__btn-group-item",
    class: {
      active: _vm.attributes.info.rewardConfigSize === 'm'
    }
  }, [_c('label', {
    staticClass: "btn btn-size"
  }, [_vm._v("\n                                    M\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    attrs: {
      "type": "radio",
      "name": "size",
      "value": "m",
      "disabled": _vm.isRewardDisabled
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigSize, "m")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigSize", "m")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-remark"
  }, [_vm._v("รอบอก 38 นิ้ว")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__btn-group-item",
    class: {
      active: _vm.attributes.info.rewardConfigSize === 'f'
    }
  }, [_c('label', {
    staticClass: "btn btn-size"
  }, [_vm._v("\n                                    F\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    attrs: {
      "type": "radio",
      "name": "size",
      "value": "f",
      "disabled": _vm.isRewardDisabled
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigSize, "f")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigSize", "f")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-remark"
  }, [_vm._v("รอบอก 40 นิ้ว")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__btn-group-item",
    class: {
      active: _vm.attributes.info.rewardConfigSize === 'l'
    }
  }, [_c('label', {
    staticClass: "btn btn-size"
  }, [_vm._v("\n                                    L\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    attrs: {
      "type": "radio",
      "name": "size",
      "value": "l",
      "disabled": _vm.isRewardDisabled
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigSize, "l")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigSize", "l")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-remark"
  }, [_vm._v("รอบอก 42 นิ้ว")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__btn-group-item",
    class: {
      active: _vm.attributes.info.rewardConfigSize === 'xl'
    }
  }, [_c('label', {
    staticClass: "btn btn-size"
  }, [_vm._v("\n                                    XL\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    attrs: {
      "type": "radio",
      "name": "size",
      "value": "xl",
      "disabled": _vm.isRewardDisabled
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigSize, "xl")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigSize", "xl")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-remark"
  }, [_vm._v("รอบอก 44 นิ้ว")])])]), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกขนาดเสื้อ")]) : _vm._e()])])]) : _vm._e()])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg",
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_vm._v("\n                  รับเสื้อยืดรุ่นพิเศษจาก ad addict "), _c('small', [_vm._v("พร้อมจัดส่งให้ถึงบ้านหลังจากจบโครงการ (บริจาค 500 บาทขึ้นไป)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "value": "ad-addict",
      "disabled": _vm.isRewardDisabled
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardProduct, "ad-addict")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", "ad-addict")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attributes.info.rewardProduct === 'ad-addict'),
      expression: "attributes.info.rewardProduct === 'ad-addict'"
    }],
    staticClass: "slide-down-wrapper",
    class: {
      disable: _vm.product.price < 500
    }
  }, [_c('div', {
    staticClass: "form__section block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--lmt-deu"
  }, [_c('div', {
    staticClass: "wrapper-form__item--scroll"
  }, [_c('div', {
    staticClass: "block radius border mb-10"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                เสื้อยืดรุ่นพิเศษ จาก ad addict \"ลูกค้าแอพพรูปค่ะ\"\n                                "), _c('div', {
    staticClass: "text-remark"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "type": "radio",
      "name": "radio-t-shirt_addict",
      "value": "เสื้อยืดรุ่นพิเศษ จาก ad addict ลูกค้าแอพพรูปค่ะ"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "เสื้อยืดรุ่นพิเศษ จาก ad addict ลูกค้าแอพพรูปค่ะ")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "เสื้อยืดรุ่นพิเศษ จาก ad addict ลูกค้าแอพพรูปค่ะ")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-15"
  }, [_vm._v("ขนาดเสื้อ")]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกขนาด --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "s"
    }
  }, [_vm._v("S - รอบอก 36 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("M - รอบอก 38 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "f"
    }
  }, [_vm._v("F - รอบอก 40 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "l"
    }
  }, [_vm._v("L - รอบอก 42 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL - รอบอก 44 นิ้ว")])])]), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกขนาดเสื้อ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/shirt1_ad.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-ad-01.jpg",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                เสื้อยืดรุ่นพิเศษ จาก ad addict \"ลูกค้าชอบแล้วค่ะ\"\n                                "), _c('div', {
    staticClass: "text-remark"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled,
      "type": "radio",
      "name": "radio-t-shirt_addict",
      "value": "เสื้อยืดรุ่นพิเศษ จาก ad addict ลูกค้าชอบแล้วค่ะ"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "เสื้อยืดรุ่นพิเศษ จาก ad addict ลูกค้าชอบแล้วค่ะ")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "เสื้อยืดรุ่นพิเศษ จาก ad addict ลูกค้าชอบแล้วค่ะ")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-15"
  }, [_vm._v("ขนาดเสื้อ")]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกขนาด --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "s"
    }
  }, [_vm._v("S - รอบอก 36 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("M - รอบอก 38 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "f"
    }
  }, [_vm._v("F - รอบอก 40 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "l"
    }
  }, [_vm._v("L - รอบอก 42 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL - รอบอก 44 นิ้ว")])])]), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกขนาดเสื้อ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/shirt2_ad.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-ad-02.jpg",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                เสื้อยืดรุ่นพิเศษ จาก ad addict \"ไอเดียนี้พี่ชอบค่ะ\"\n                                "), _c('div', {
    staticClass: "text-remark"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled,
      "type": "radio",
      "name": "radio-t-shirt_addict",
      "value": "เสื้อยืดรุ่นพิเศษ จาก ad addict ไอเดียนี้พี่ชอบค่ะ"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "เสื้อยืดรุ่นพิเศษ จาก ad addict ไอเดียนี้พี่ชอบค่ะ")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "เสื้อยืดรุ่นพิเศษ จาก ad addict ไอเดียนี้พี่ชอบค่ะ")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-15"
  }, [_vm._v("ขนาดเสื้อ")]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกขนาด --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "s"
    }
  }, [_vm._v("S - รอบอก 36 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("M - รอบอก 38 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "f"
    }
  }, [_vm._v("F - รอบอก 40 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "l"
    }
  }, [_vm._v("L - รอบอก 42 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL - รอบอก 44 นิ้ว")])])]), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกขนาดเสื้อ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/shirt3_ad.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-ad-03.jpg",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                เสื้อยืดรุ่นพิเศษ จาก ad addict \"ใส่แล้วขายงานผ่าน\"\n                                "), _c('div', {
    staticClass: "text-remark"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled,
      "type": "radio",
      "name": "radio-t-shirt_addict",
      "value": "เสื้อยืดรุ่นพิเศษ จาก ad addict ใส่แล้วขายงานผ่าน"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "เสื้อยืดรุ่นพิเศษ จาก ad addict ใส่แล้วขายงานผ่าน")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "เสื้อยืดรุ่นพิเศษ จาก ad addict ใส่แล้วขายงานผ่าน")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-15"
  }, [_vm._v("ขนาดเสื้อ")]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกขนาด --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "s"
    }
  }, [_vm._v("S - รอบอก 36 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("M - รอบอก 38 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "f"
    }
  }, [_vm._v("F - รอบอก 40 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "l"
    }
  }, [_vm._v("L - รอบอก 42 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL - รอบอก 44 นิ้ว")])])]), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกขนาดเสื้อ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/shirt4_ad.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-ad-04.jpg",
      "alt": ""
    }
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg",
    class: {
      disable: _vm.isRewardDisabled699
    }
  }, [_vm._v("\n                  รับของที่ระลึกลายพิเศษ จากศิลปินใน Community Illustrator "), _c('small', [_vm._v("คนที่คุณชื่นชอบ จัดส่งให้ถึงบ้านหลังจากจบโครงการทั้งหมด 17 ศิลปิน")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "value": "merchandise",
      "disabled": _vm.isRewardDisabled699
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardProduct, "merchandise")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", "merchandise")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attributes.info.rewardProduct === 'merchandise'),
      expression: "attributes.info.rewardProduct === 'merchandise'"
    }],
    staticClass: "slide-down-wrapper",
    class: {
      disable: _vm.product.price < 699
    }
  }, [_c('div', {
    staticClass: "form__section block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--lmt-deu"
  }, [_c('div', {
    staticClass: "wrapper-form__item--scroll"
  }, [_c('div', {
    staticClass: "block radius border mb-10 lmt-01"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                เสื้อยืดรุ่นพิเศษจาก Puck\n                                "), _c('div', {
    staticClass: "text-remark"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "เสื้อยืดรุ่นพิเศษจาก Puck"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "เสื้อยืดรุ่นพิเศษจาก Puck")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "เสื้อยืดรุ่นพิเศษจาก Puck")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-15"
  }, [_vm._v("ขนาดเสื้อ")]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกขนาด --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "s"
    }
  }, [_vm._v("S - รอบอก 36 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("M - รอบอก 38 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "f"
    }
  }, [_vm._v("F - รอบอก 40 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "l"
    }
  }, [_vm._v("L - รอบอก 42 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL - รอบอก 44 นิ้ว")])])]), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกขนาดเสื้อ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--01",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-01_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-01.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-02"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                ชุดเข็มกลัดโลหะจาก Nut Dao\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }, [_vm._v("1 ชุดมีทั้งหมด 2 ชิ้น")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "type": "radio",
      "name": "radio-merchandise",
      "value": "ชุดเข็มกลัดโลหะจาก Nut Dao"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "ชุดเข็มกลัดโลหะจาก Nut Dao")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "ชุดเข็มกลัดโลหะจาก Nut Dao")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--02",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-02_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-02.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-03"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                ชุดเข็มกลัดอะคริลิคจาก Kanith\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }, [_vm._v("1 ชุดมีทั้งหมด 4 ชิ้น")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "ชุดเข็มกลัดอะคริลิคจาก Kanith"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "ชุดเข็มกลัดอะคริลิคจาก Kanith")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "ชุดเข็มกลัดอะคริลิคจาก Kanith")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--03",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-03_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-03.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-04"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                ถุงผ้าแคนวาสจาก TUNA Dunn\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "ถุงผ้าแคนวาสจาก TUNA Dunn"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "ถุงผ้าแคนวาสจาก TUNA Dunn")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "ถุงผ้าแคนวาสจาก TUNA Dunn")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--04",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-04_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-04.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-05"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                Shopping Bag จาก Benxblues\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }, [_vm._v("ถุงผ้าร่มแบบพกพาพับได้")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "Shopping Bag จาก Benxblues"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "Shopping Bag จาก Benxblues")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "Shopping Bag จาก Benxblues")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--05",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-05_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-05.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-06"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                โปสเตอร์จาก Nakrob Moonmanas\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }, [_vm._v("งานพิมพ์ Digital Collage ขนาด A2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "โปสเตอร์จาก Nakrob Moonmanas"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "โปสเตอร์จาก Nakrob Moonmanas")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "โปสเตอร์จาก Nakrob Moonmanas")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--06",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-06_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-06.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-07"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                เสื้อยืดรุ่นพิเศษจาก Juli Baker and Summer\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "เสื้อยืดรุ่นพิเศษจาก Juli Baker and Summer"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "เสื้อยืดรุ่นพิเศษจาก Juli Baker and Summer")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "เสื้อยืดรุ่นพิเศษจาก Juli Baker and Summer")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-15"
  }, [_vm._v("ขนาดเสื้อ")]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigSize),
      expression: "attributes.info.rewardConfigSize"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกขนาด --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "s"
    }
  }, [_vm._v("S - รอบอก 36 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("M - รอบอก 38 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "f"
    }
  }, [_vm._v("F - รอบอก 40 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "l"
    }
  }, [_vm._v("L - รอบอก 42 นิ้ว")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL - รอบอก 44 นิ้ว")])])]), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกขนาดเสื้อ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--07",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-07_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-07.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-08"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                โปสเตอร์จาก LoveSyrup\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }, [_vm._v("งานพิมพ์ ขนาด A2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "โปสเตอร์จาก LoveSyrup"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "โปสเตอร์จาก LoveSyrup")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "โปสเตอร์จาก LoveSyrup")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--08",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-08_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-08.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-09"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                ถุงผ้าแคนวาสจาก Tum Ulit\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "ถุงผ้าแคนวาสจาก Tum Ulit"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "ถุงผ้าแคนวาสจาก Tum Ulit")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "ถุงผ้าแคนวาสจาก Tum Ulit")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--09",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-09_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-09.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-10"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                หมวกปักลายจาก Banana Blah Blah\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "หมวกปักลายจาก Banana Blah Blah"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "หมวกปักลายจาก Banana Blah Blah")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "หมวกปักลายจาก Banana Blah Blah")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--10",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-10_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-10.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-11"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                แก้วกาแฟจาก Jeep Kongdechakul\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "แก้วกาแฟจาก Jeep Kongdechakul"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "แก้วกาแฟจาก Jeep Kongdechakul")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "แก้วกาแฟจาก Jeep Kongdechakul")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--11",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-11_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-11.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-12"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                ถุงผ้าแคนวาสจาก Cus Cus\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "ถุงผ้าแคนวาสจาก Cus Cus"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "ถุงผ้าแคนวาสจาก Cus Cus")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "ถุงผ้าแคนวาสจาก Cus Cus")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-12_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-12.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-13"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                ชุดโปสการ์ดและ Masking Tape จาก Louis Sketcher\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }, [_vm._v("โปสการ์ด 5 ชิ้น + Maskting Tape 1 ชิ้น")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "ชุดโปสการ์ดและ Masking Tape จาก Louis Sketcher"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "ชุดโปสการ์ดและ Masking Tape จาก Louis Sketcher")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "ชุดโปสการ์ดและ Masking Tape จาก Louis Sketcher")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--13",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-13_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-13.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-14"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                หมอนไดคัทจาก Apolar\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "หมอนไดคัทจาก Apolar"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "หมอนไดคัทจาก Apolar")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "หมอนไดคัทจาก Apolar")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--14",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-14_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-14.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-15"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                หมอนไดคัทจาก Sahred Toy\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "หมอนไดคัทจาก Sahred Toy"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "หมอนไดคัทจาก Sahred Toy")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "หมอนไดคัทจาก Sahred Toy")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-15_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-15.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-16"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                ถุงผ้าแคนวาสจาก Munin\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "ถุงผ้าแคนวาสจาก Munin"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "ถุงผ้าแคนวาสจาก Munin")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "ถุงผ้าแคนวาสจาก Munin")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--16",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-16_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-16.png",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block radius border mb-10 lmt-17"
  }, [_c('label', {
    staticClass: "form__radio-lg form__radio-lg--sub"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9"
  }, [_vm._v("\n                                ชุดหนังสือและเครื่องเขียนจาก Sa-ard\n                                "), _c('div', {
    staticClass: "text-remark mb-15"
  }, [_vm._v("หนังสือ 'การศึกษาของกระป๋องมีฝัน' + ชุดเครื่องเขียน Grey Ray")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    attrs: {
      "disabled": _vm.isRewardDisabled699,
      "type": "radio",
      "name": "radio-merchandise",
      "value": "ชุดหนังสือและเครื่องเขียนจาก Sa-ard"
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardConfigChoice, "ชุดหนังสือและเครื่องเขียนจาก Sa-ard")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardConfigChoice", "ชุดหนังสือและเครื่องเขียนจาก Sa-ard")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('div', {
    staticClass: "lmt-profile lmt-profile--17",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage('/static/img/limited-edu/lmt-product-17_full.jpg')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/limited-edu/lmt-product-17.png",
      "alt": ""
    }
  })])])])])])])])])])])], 1), _vm._v(" "), _c('donor-info', {
    staticClass: "pt-15",
    model: {
      value: (_vm.attributes.info.name),
      callback: function($$v) {
        _vm.$set(_vm.attributes.info, "name", $$v)
      },
      expression: "attributes.info.name"
    }
  }), _vm._v(" "), _c('page-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.attributes.page),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "page", $$v)
      },
      expression: "attributes.page"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "product": _vm.product,
      "attributes": _vm.attributes,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn--purple btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("บริจาค")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "text-center mb-20",
    attrs: {
      "data-v-1f20e9ef": ""
    }
  }, [_c('img', {
    staticClass: "pd-15 ma-auto d-block",
    attrs: {
      "src": "/static/img/limited-edu/logo-lmt-01.png",
      "alt": "Limited Education",
      "width": "260px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03afe97e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/limited-education.vue
// module id = 1028
// module chunks = 1